<template>
  <div class="xn-navbar">
    <div class="container">
      <div class="logo" @click="handleClickLogo">
        <img src="../../assets/logo.png" alt="云上星牛" />
      </div>

      <div class="btn-group d-block d-lg-none">
        <el-dropdown trigger="click">
          <!-- <span class="el-dropdown-link"> </span> -->
          <el-button class="el-dropdown-link" icon="el-icon-menu"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link class="dropdown-item" to="/index">首页 </router-link>
            </el-dropdown-item>
            <el-divider class="m-0"></el-divider>
            <el-dropdown-item>
              <router-link class="dropdown-item" to="/introduce/product">
                产品介绍
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link
                class="dropdown-item"
                to="/introduce/functionIntroduction"
              >
                功能介绍
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link class="dropdown-item" to="/introduce/functionUsage">
                功能使用
              </router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link class="dropdown-item" to="/introduce/advantage">
                竞争优势
              </router-link>
            </el-dropdown-item>
            <el-divider class="m-0"></el-divider>
            <el-dropdown-item>
              <router-link class="dropdown-item" to="/about"
                >联系方式
              </router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="d-none d-lg-block">
        <ul class="nav">
          <li class="nav-item">
            <router-link
              class="nav-link"
              :class="{ active: path == '/index' }"
              to="/index"
              >首页
            </router-link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              data-toggle="dropdown"
              role="button"
              aria-expanded="false"
              :class="{ active: path.indexOf('introduce') > -1 }"
            >
              平台介绍
            </a>
            <div class="dropdown-menu">
              <router-link class="dropdown-item" to="/introduce/product">
                产品介绍
              </router-link>
              <router-link
                class="dropdown-item"
                to="/introduce/functionIntroduction"
              >
                功能介绍
              </router-link>
              <router-link class="dropdown-item" to="/introduce/functionUsage">
                功能使用
              </router-link>
              <router-link class="dropdown-item" to="/introduce/advantage">
                竞争优势
              </router-link>
            </div>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :class="{ active: path == '/about' }"
              to="/about"
              >联系方式
            </router-link>
          </li>
          <li class="nav-item">
            <el-popover placement="top-start" width="200" trigger="hover">
              <el-image :src="src"></el-image>
              <div class="nav-link" slot="reference">下载</div>
            </el-popover>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Popover,
  Image,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button,
  Divider,
} from "element-ui";
export default {
  components: {
    [Popover.name]: Popover,
    [Image.name]: Image,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Divider.name]: Divider,
  },
  data() {
    return {
      path: "/index",
      src: require("../../assets/icon-3.png"),
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.path = route.path;
        console.log(this.path, ":this.path");
      },
      immediate: true,
    },
  },
  methods: {
    handleClickLogo() {
      // this.$router.push({
      //   path: "/index",
      // });
      window.location.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.xn-navbar {
  width: 100%;
  background: rgba(255, 255, 255, 0.35);
  border-bottom: 1px solid #ededed;

  .container {
    height: 120px;
    display: flex;
    justify-items: center;
    align-items: center;
    justify-content: space-between;
    .logo {
      width: 101px;
      height: 80px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.nav-item {
  margin: 20px;
  font-size: 16px;
  .nav-link {
    color: #000;
    cursor: pointer;
  }

  .active {
    color: #ef7526;
  }

  .dropdown-item:hover {
    background: #ef7526 !important;
    color: #fff !important;
  }
}
</style>